interface ICatCrashEvent {
    [key: string]: IContentCrashEvent;
}

export interface IContentCrashEvent {
    tipo: string;
    modulo: string;
    funcion: string;
    identificador: string;
}

export const GTMEventsCrash: ICatCrashEvent = {
    muralApi: {
        tipo: 'api', // Tipo de error
        modulo: 'parati', // Modulo
        funcion: 'callbackParaTi', // Funcion ejecutada
        identificador: 'payload-error' // Identificador
    },
    updatedDataApi: {
        tipo: 'api',
        modulo: 'appinit',
        funcion: 'updatedData',
        identificador: 'payload-error'
    },
    inicioAppApi: {
        tipo: 'api',
        modulo: 'appinit',
        funcion: 'errorCallbackInicioApp',
        identificador: 'payload-error'
    },
    updateCollect: {
        tipo: 'collection',
        modulo: 'updateapp',
        funcion: 'catchError',
        identificador: 'collection-error'
    },
    maintenanceCollect: {
        tipo: 'collection',
        modulo: 'maintenancescreen',
        funcion: 'catchError',
        identificador: 'collection-error'
    },
    legalModalApi: {
        tipo: 'api',
        modulo: 'legalmodal',
        funcion: 'callbackAcceptLegals',
        identificador: 'payload-error'
    },
    getLegalesApi: {
        tipo: 'api',
        modulo: 'getlegales',
        funcion: 'callbackErrorPoliticas',
        identificador: 'payload-error'
    },
    loginApi: {
        tipo: 'api',
        modulo: 'login',
        funcion: 'callbackErrorAuthLogin',
        identificador: 'payload-error'
    },
    registroBodegaNudTelApi: {
        tipo: 'api',
        modulo: 'registrobodeganudtel',
        funcion: 'callbackErrorAuthRegister',
        identificador: 'payload-error'
    },
    registerSendSMSPlugin: {
        tipo: 'plugin',
        modulo: 'registersendsms',
        funcion: 'phoneNumberError',
        identificador: 'plugin-verify-phone-error'
    },
    recoveryPhoneApi: {
        tipo: 'api',
        modulo: 'recoveryphone',
        funcion: 'AuthTelDetallista',
        identificador: 'payload-error'
    },
    recoverySendSMSPlugin: {
        tipo: 'plugin',
        modulo: 'recoverysendsms',
        funcion: 'phoneNumberError',
        identificador: 'plugin-verify-phone-error'
    },
    registerCodePlugin: {
        tipo: 'plugin',
        modulo: 'registercode',
        funcion: 'signInWithCredential',
        identificador: 'plugin-code-sms-error'
    },
    recoveryCodePlugin: {
        tipo: 'plugin',
        modulo: 'recoverycode',
        funcion: 'signInWithCredential',
        identificador: 'plugin-code-sms-error'
    },
    getConfigProfileRegisterApi: {
        tipo: 'api',
        modulo: 'getconfigprofileregister',
        funcion: 'callbackErrorConfiguracion',
        identificador: 'payload-error'
    },
    saveRegisterApi: {
        tipo: 'api',
        modulo: 'updatetendero',
        funcion: 'saveRegisterError',
        identificador: 'payload-error'
    },
    ventasMesApi: {
        tipo: 'api',
        modulo: 'getmonthsales',
        funcion: 'callbackVentasMes',
        identificador: 'payload-error'
    },
    ventasMesSeleccionApi: {
        tipo: 'api',
        modulo: 'getdaysweeks',
        funcion: 'VentasTicketsMesSeleccion',
        identificador: 'payload-error'
    },
    mesSeleccionApi: {
        tipo: 'api',
        modulo: 'getpresale',
        funcion: 'VentasTicketsMesSeleccion',
        identificador: 'payload-error'
    },
    filePdfPlugin: {
        tipo: 'plugin',
        modulo: 'writefileticket',
        funcion: 'savebase64AsPDF',
        identificador: 'plugin-write-file-error'
    },
    getCDGApi: {
        tipo: 'api',
        modulo: 'getdg',
        funcion: 'callbackSuccessProgram',
        identificador: 'payload-error'
    },
    getTicketPromedioApi: {
        tipo: 'api',
        modulo: 'getticketpromedio',
        funcion: 'callbackSuccessProgram',
        identificador: 'payload-error'
    },
    getConfigPremiadosCollect: {
        tipo: 'collection',
        modulo: 'getconfigpremiados',
        funcion: 'openPremiados',
        identificador: 'collection-error'
    },
    sharedUrlPremia2Plugin: {
        tipo: 'plugin',
        modulo: 'sharedurlpremia2',
        funcion: 'callbackErrorShareUrl',
        identificador: 'plugin-social-sharing-error'
    },
    getConfigButtonsPremiadosHistCollect: {
        tipo: 'collection',
        modulo: 'getconfigbuttonspremiadoshist',
        funcion: 'obtieneBodegaNud',
        identificador: 'collection-error'
    },
    getEjecucionApi: {
        tipo: 'api',
        modulo: 'getejecucion',
        funcion: 'callbackEjecucion',
        identificador: 'payload-error'
    },
    sendEjecucionApi: {
        tipo: 'api',
        modulo: 'sendejecucion',
        funcion: 'callbackTaskEjecucion',
        identificador: 'payload-error'
    },
    activateCameraOverlayPlugin: {
        tipo: 'plugin',
        modulo: 'activatecameraoverlay',
        funcion: 'intervalCameraOverlay',
        identificador: 'plugin-camerapreview-error'
    },
    closeCameraPlugin: {
        tipo: 'plugin',
        modulo: 'stopcamera',
        funcion: 'closeCamera',
        identificador: 'plugin-camerapreview-error'
    },
    ejecucionresultApi: {
        tipo: 'api',
        modulo: 'ejecucionresult',
        funcion: 'callbackResultEjecucion',
        identificador: 'payload-error'
    },
    getOrdersApi: {
        tipo: 'api',
        modulo: 'getorderspedidos',
        funcion: 'callbackGetOrders',
        identificador: 'payload-error'
    },
    cancelOrdersApi: {
        tipo: 'api',
        modulo: 'cancelorders',
        funcion: 'callbackCancelOrders',
        identificador: 'payload-error'
    },
    resumeDetailOrderApi: {
        tipo: 'api',
        modulo: 'resumedetailorder',
        funcion: 'callBackOrder',
        identificador: 'payload-error'
    },
    getProductsApi: {
        tipo: 'api',
        modulo: 'getproducts',
        funcion: 'callbackSuccessGetProducts',
        identificador: 'payload-error'
    },
    getProductsApiNoValues: {
        tipo: 'api',
        modulo: 'getproducts',
        funcion: 'callbackSuccessGetProducts',
        identificador: 'nodata-error'
    },
    getPromosEcommerceApi: {
        tipo: 'api',
        modulo: 'getpromosecommerce',
        funcion: 'callbackPromosEcommerce',
        identificador: 'payload-error'
    },
    sendCartApi: {
        tipo: 'api',
        modulo: 'sendcart',
        funcion: 'callbackSendCart',
        identificador: 'payload-error'
    },
    sendOrderApi: {
        tipo: 'api',
        modulo: 'sendorder',
        funcion: 'callbackOrders',
        identificador: 'payload-error'
    },
    getPortfolioApi: {
        tipo: 'api',
        modulo: 'getportfolio',
        funcion: 'obtienePortafolio',
        identificador: 'payload-error'
    },
    getConfigButtonsPremiadosCollect: {
        tipo: 'collection',
        modulo: 'getconfigbuttonspremiados',
        funcion: 'setView',
        identificador: 'collection-error'
    },
    getMechanicsApi: {
        tipo: 'api',
        modulo: 'getMechanicsProgram',
        funcion: 'getServer',
        identificador: 'payload-error'
    },
    networkPlugin: {
        tipo: 'plugin',
        modulo: 'network',
        funcion: 'callbackConnect',
        identificador: 'not-connection'
    },
    ProgramCloseCollect: {
        tipo: 'collection',
        modulo: 'prgclssvc',
        funcion: 'catchError',
        identificador: 'collection-error'
    },
    recoveryPassApi: {
        tipo: 'api',
        modulo: 'recoverypass',
        funcion: 'updatePasswordTendero',
        identificador: 'payload-error'
    },
    calificanosApi: {
        tipo: 'api',
        modulo: 'questionscontactrateus',
        funcion: 'errorCallbackPreguntasContacto',
        identificador: 'payload-error'
    },
    callNumberRateUsPlugin: {
        tipo: 'plugin',
        modulo: 'callnumberrateus',
        funcion: 'llamar',
        identificador: 'plugin-callnumber-error'
    },
    sendRespuestaCalificanosApi: {
        tipo: 'api',
        modulo: 'sendanswerrateus',
        funcion: 'mandarDatos',
        identificador: 'payload-error'
    },
    getProfileApi: {
        tipo: 'api',
        modulo: 'getprofile',
        funcion: 'callbackGetProfile',
        identificador: 'payload-error'
    },
    updateProfileApi: {
        tipo: 'api',
        modulo: 'updateprofile',
        funcion: 'callBackUserUpdated',
        identificador: 'payload-error'
    },
    currentPassApi: {
        tipo: 'api',
        modulo: 'currenpass',
        funcion: 'callBackCurrentPass',
        identificador: 'payload-error'
    },
    newPhoneApi: {
        tipo: 'api',
        modulo: 'validnewphone',
        funcion: 'callBackNewPhone',
        identificador: 'payload-error'
    },
    profileSendSMSPlugin: {
        tipo: 'plugin',
        modulo: 'profilesendsms',
        funcion: 'callbackErrorID',
        identificador: 'plugin-verify-phone-error'
    },
    profileCodePlugin: {
        tipo: 'plugin',
        modulo: 'profilecode',
        funcion: 'callbackErrorValidateCode',
        identificador: 'plugin-code-sms-error'
    },
    cancelAccountApi: {
        tipo: 'api',
        modulo: 'cancelaccount',
        funcion: 'callbackCancelAccount',
        identificador: 'payload-error'
    },
    getOptionsAssistanceApi: {
        tipo: 'api',
        modulo: 'getoptionsassistance',
        funcion: 'callbackGetOptions',
        identificador: 'payload-error'
    },
    saveAssistanceApi: {
        tipo: 'api',
        modulo: 'saveassistance',
        funcion: 'callbackSaveAssistance',
        identificador: 'payload-error'
    },
    getNotificationsApi: {
        tipo: 'api',
        modulo: 'getnotifications',
        funcion: 'callbackNotificacion',
        identificador: 'payload-error'
    },
    getContactApi: {
        tipo: 'api',
        modulo: 'getcontact',
        funcion: 'obtieneLineaContacto',
        identificador: 'payload-error'
    },
    callNumberContactPlugin: {
        tipo: 'plugin',
        modulo: 'callnumbercontact',
        funcion: 'callNumber',
        identificador: 'plugin-callnumber-error'
    },
    listGamesApi: {
        tipo: 'api',
        modulo: 'listgames',
        funcion: 'callbackListGames',
        identificador: 'payload-error'
    },
    userInfoGamesApi: {
        tipo: 'api',
        modulo: 'userinfogames',
        funcion: 'callbackUserInfoGame',
        identificador: 'payload-error'
    },
    statusLifesApi: {
        tipo: 'api',
        modulo: 'lifesmodaleffets',
        funcion: 'catchError',
        identificador: 'payload-error'
    },
    getRatingApi: {
        tipo: 'api',
        modulo: 'getrating',
        funcion: 'catchError',
        identificador: 'payload-error'
    },
    getRatingByGameApi: {
        tipo: 'api',
        modulo: 'getratingbygame',
        funcion: 'catchError',
        identificador: 'payload-error'
    },
    startGameApi: {
        tipo: 'api',
        modulo: 'startgame',
        funcion: 'catchError',
        identificador: 'payload-error'
    },
    sendStatusLifesModalApi: {
        tipo: 'api',
        modulo: 'sendstatuslifesmodal',
        funcion: 'catchError',
        identificador: 'payload-error'
    },
    sendConnectionApi: {
        tipo: 'api',
        modulo: 'sendconnection',
        funcion: 'catchError',
        identificador: 'payload-error'
    },
    saveGoingApi: {
        tipo: 'api',
        modulo: 'savegoing',
        funcion: 'callbackSaveGoing',
        identificador: 'payload-error'
    },
    createUnityInstance: {
        tipo: 'unity',
        modulo: 'createunityinstance',
        funcion: 'callbackInstaceError',
        identificador: 'unity-error'
    },
    sesionRegistroCreceMasApi: {
        tipo: 'api',
        modulo: 'sesionregistrocrecemas',
        funcion: 'callbackErrorRegistroSesion',
        identificador: 'payload-error'
    },
    getNextRegistroSesion: {
        tipo: 'api',
        modulo: 'getdashboard',
        funcion: 'callbackNextRegistroSesion',
        identificador: 'payload-error'
    },
    getDashboardApi: {
        tipo: 'api',
        modulo: 'getdashboard',
        funcion: 'callbackErrorDashboard',
        identificador: 'payload-error'
    },
    sesionNextDashboard: {
        tipo: 'api',
        modulo: 'sesionregistrocrecemas',
        funcion: 'callbackNextDashboard',
        identificador: 'payload-error'
    },
    resolverUrlCreceMasApi: {
        tipo: 'api',
        modulo: 'resolverurlcrecemas',
        funcion: 'callbackNextResolveURL',
        identificador: 'payload-error'
    },
    resolverUrlCreceMasPlugin: {
        tipo: 'plugin',
        modulo: 'sharedcrecemas',
        funcion: 'callbackErrorShare',
        identificador: 'plugin-social-sharing-error'
    },
    getGJCPApi: {
        tipo: 'api',
        modulo: 'getgjcp',
        funcion: 'getGJCPTendero',
        identificador: 'payload-error'
    },
    calculaTicketPrmdGJCPApi: {
        tipo: 'api',
        modulo: 'gjcpcalculaticketPromedio',
        funcion: 'calculaTicketPromedio',
        identificador: 'payload-error'
    },
    getSGApi: {
        tipo: 'api',
        modulo: 'getsg',
        funcion: 'getSGTendero',
        identificador: 'payload-error'
    },
    calculaTicketPrmdSGApi: {
        tipo: 'api',
        modulo: 'sgcalculaticketPromedio',
        funcion: 'calculaTicketPromedio',
        identificador: 'payload-error'
    },
    resetUserApi: {
        tipo: 'api', // Tipo de error
        modulo: 'resetuser', // Modulo
        funcion: 'callbackResetUser', // Funcion ejecutada
        identificador: 'payload-error' // Identificador
    },
    impulsaGEPPApi: {
        tipo: 'api', // Tipo de error
        modulo: 'impulsagepp', // Modulo
        funcion: 'callbackImpulsaGEPP', // Funcion ejecutada
        identificador: 'payload-error' // Identificador
    },
    statusPromotionModalApi: {
        tipo: 'api',
        modulo: 'statuspromotionmodalsleffets',
        funcion: 'catchError',
        identificador: 'payload-error'
    },
    updatePromotionModalApi: {
        tipo: 'api',
        modulo: 'updatePromotionmodalsleffets',
        funcion: 'catchError',
        identificador: 'payload-error'
    },
    statusModalApi: {
        tipo: 'api',
        modulo: 'statusmodalsleffets',
        funcion: 'catchError',
        identificador: 'payload-error'
    },
    updateModalApi: {
        tipo: 'api',
        modulo: 'updatemodalsleffets',
        funcion: 'catchError',
        identificador: 'payload-error'
    },
    getEnfriadoresApi: {
        tipo: 'api',
        modulo: 'enfriadorespage',
        funcion: 'getEnfriadores',
        identificador: 'payload-error'
    }
};
